import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAppSecurity , setPageSize } from "@/slices/accessManager/AccessAppSecuritySlice";
import Pagination from "@/components/Pagination";
import Loader from "@/components/Loader";
import EditableTable from "./ProjectSettingsTable";
import SimplePagination from "@/components/SimplePagination";
import PanelUserSearch from "@/components/PanelUserSearch";
import PageSizeSelector from "@/components/PageSizeSelector";

const SecurityEvent = () => {
  const dispatch = useDispatch();
  const { accessAppSecurityList, currentPage, totalPages, status,  search , pageSize } = useSelector(
    (state) => state.accessAppSecurity
  );

  const [searchInput, setSearchInput] = useState(search || "");
  


    const headers = accessAppSecurityList?.result?.length > 0 ? Object.keys(accessAppSecurityList.result[0]).filter((key) => key !== 'id') : [];


  useEffect(() => {
    dispatch(fetchAppSecurity({page: 1 , search}));
  }, [dispatch]);




    const isSearching = searchInput && searchInput.trim() !== "";
    const hasData = accessAppSecurityList?.result?.length > 0;
  
     // ✅ Page size change
      const handlePageSizeChange = (size) => {
        dispatch(setPageSize(size)); // update slice
        dispatch(fetchAppSecurity({ page: 1 , search}));
      }; 
  
     useEffect(() => {
       setSearchInput(search || "");
     }, [search]);
  
        // ✅ Debounced search (MAIN CONTROL)
      useEffect(() => {
        const timer = setTimeout(() => {
          dispatch(fetchAppSecurity({ page: 1, search: searchInput }));
        }, 800);
    
        return () => clearTimeout(timer);
      }, [searchInput]);



  if (status === "loading") {
    return (
      <div className="w-full pt-20 flex justify-center">
        <Loader />
      </div>
    );
  }
 
  return (
    <div className="w-full flex items-center flex-col">

        <PanelUserSearch  
      value={searchInput}
      onChange={setSearchInput}
      />


      <div className="max-w-[90%]">
         {hasData ? (
        <EditableTable
          headers={headers}
          rows={accessAppSecurityList?.result}
          hideChangeLog={true}
        />
        ) : (
    <div className="w-full flex flex-col items-center justify-center py-20 text-gray-500">

      {/* Icon */}
      <div className="text-5xl mb-3">🔍</div>

      {/* Message */}
      {searchInput ? (
        <>
          <p className="text-lg font-medium">No results found</p>
          <p className="text-sm mt-1">
            for "<span className="font-semibold">{searchInput}</span>"
          </p>
        </>
      ) : (
        <>
          <p className="text-lg font-medium">No Data Available</p>
          <p className="text-sm mt-1">
            There are no users to display
          </p>
        </>
      )}

    </div>
  )}

      </div>

    {!(isSearching && !hasData) && (
  <div className="flex mt-4 items-center justify-between w-11/12">
    <PageSizeSelector
      pageSize={pageSize}
      setPageSize={handlePageSizeChange}
    />

  <SimplePagination
    currentPage={currentPage}
    setCurrentPage={(page) =>
      dispatch(fetchAppSecurity({ page , search : searchInput}))
    }
    totalPages={totalPages}
  />
    </div>
    )}

    </div>
  );
};

export default SecurityEvent;
